angular.module('invoice')
    .constant('InvoiceBgtGroupConst', {
        eventUpdate: 'invoice-bgt-group.updated'
    })
    .factory('InvoiceBgtGroup', function ($resource) {
        return $resource('/crm/api/invoice-bgt-group/:id', {}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT', params: {id: "@id"}},
            remove: {method: 'DELETE'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/invoice-bgt-group/autocomplete'}
        });
    })
    .service('InvoiceBgtGroupService', function ($rootScope, toastr, modals, InvoiceBgtGroup, InvoiceBgtGroupConst) {
        this.edit = id => {
            return InvoiceBgtGroup.get({id: id}, entity => editModal(entity))
        }
        this.addModal = (properties) => {
            let entity = {
                id: null
            }
            angular.extend(entity, properties);
            return editModal(entity)
        };
        this.remove = item => {
            return modals.confirmDelete(item.name, () => InvoiceBgtGroup.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(InvoiceBgtGroupConst.eventUpdate)));
        }

        function editModal(entity) {
            return modals.open('app/invoice/bgt-group/edit-modal.html', 'InvoiceBgtGroupDialogController', entity, {size: "sm"}, "$ctrl");
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceBgtGroupList', {
            parent: 'app',
            url: '/settings/invoice-bgt-group?{page:int}&{size:int}&sort&search&type&parent',
            data: {
                authorities: ['ROLE_INVOICE_BGT_READ']
            },
            views: {
                'content@': 'invoiceBgtGroupList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (InvoiceBgtGroup, $stateParams) => InvoiceBgtGroup.list(angular.copy($stateParams)).$promise
            }
        })
    })
